import styles from "./AboutSection.module.css";
import aboutImage from "./assets/student2.png";
import { Link } from "react-router-dom";

import {
  FaGlobe,
  FaUsers,
  FaGraduationCap,
  FaUniversity,
} from "react-icons/fa";

export default function AboutSection() {
  return (
    <section className={styles.aboutSection}>

      <div className={styles.container}>

        {/* IMAGE */}
        <div className={styles.imageArea}>
          <img src={aboutImage} alt="IKS Schule" />
        </div>


        {/* CONTENT */}
        <div className={styles.contentArea}>

          <h2>
            ÜBER UNS
          </h2>





          <p>
            Die IKS – Interkulturelle Schule Rhein-Main ist eine staatlich anerkannte Privatschule in Frankfurt.
            Unsere Schule zeichnet sich durch ein internationales und interkulturelles
            Profil aus. Erfahrene Lehrkräfte begleiten die Schülerinnen und Schüler
            individuell im Alltag. Dabei stehen individuelle Förderung und Talententwicklung
            ebenso im Mittelpunkt wie kulturelle Bildung und eine praxisnahe Berufsorientierung
          </p>


          <p>
            Moderne Lernumgebung und starke Werte bilden das Fundament
            für persönliches Wachstum und akademischen Erfolg.
          </p>

            <Link to="/uberuns" className={styles.btn}>
              Mehr über unsere Schule →
            </Link>


          {/* STATS */}

          <div className={styles.stats}>

            <div className={styles.card}>
              <FaGraduationCap />

              <div>
                <strong>72</strong>
                <span>
                  Jahre Erfahrung
                </span>
              </div>
            </div>



            <div className={styles.card}>
              <FaUsers />

              <div>
                <strong>600</strong>
                <span>
                  Schülerinnen<br/>
                  und Schüler
                </span>
              </div>
            </div>



            <div className={styles.card}>
              <FaGlobe />

              <div>
                <strong>40</strong>
                <span>
                  Nationen
                </span>
              </div>
            </div>



            <div className={styles.card}>
              <FaUniversity />

              <div>
                <strong>60+</strong>
                <span>
                  Lehrkräfte
                </span>
              </div>
            </div>


          </div>


        </div>


      </div>

    </section>
  );
}